import React from "react";
import { Dialog, DialogContent, Typography, Box } from "@mui/material";
import { borderRadius, styled } from '@mui/system';

interface MessagePopupProps {
  open: boolean;
  message: string;
}


interface BouncingBallProps {
  index: number;
}


const BouncingBall = styled('div')<BouncingBallProps>(({ index }) => ({
  width: '15px',
  height: '15px',
  borderRadius: '50%',
  backgroundColor: '#b5b9ca', 
  display: 'inline-block',
  margin: '0 5px',
  animation: `bounce 0.6s infinite alternate`,
  animationDelay: `${index * 0.2}s`, 
  '@keyframes bounce': {
    '0%': {
      transform: 'translateY(0)',
    },
    '100%': {
      transform: 'translateY(-10px)', 
    },
  },
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: '#3a4572',
    color: '#e6e6ea', 
    border: 'none', 
    boxShadow: 'none', 
    overflow: 'hidden', 
    margin: 'auto', 
    width: '90%',
    maxWidth: '400px', 
    padding: 0, 
  },
}));

const PopupContainer = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: 0, 
  overflow: 'hidden',
}));

const MessagePopup: React.FC<MessagePopupProps> = ({ open, message }) => {
  return (
    <StyledDialog open={open} fullWidth>
      <PopupContainer>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={2}>
          <Box display="flex" justifyContent="center">
            {[0, 1, 2].map(index => (
              <BouncingBall key={index} index={index} />
            ))}
          </Box>
          <Typography variant="body1" align="center">
            {message}
          </Typography>
        </Box>
      </PopupContainer>
    </StyledDialog>
  );
};

export default MessagePopup;